import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from 'react-helmet-async';
import App from "./App.tsx";
import "./index.css";

// Disable browser scroll restoration - we handle it manually
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Render app immediately for faster FCP
const rootElement = document.getElementById("root")!;

// Use scheduler to break up non-critical tasks
const scheduler = typeof requestIdleCallback !== 'undefined' 
  ? requestIdleCallback 
  : (cb: IdleRequestCallback) => setTimeout(cb, 1);

createRoot(rootElement).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);

// Defer device detection until after first paint
scheduler(() => {
  import("./utils/deviceDetection").then(({ initDeviceDetection }) => {
    initDeviceDetection();
  });
}, { timeout: 1000 });

// Defer visitor tracking and performance monitoring until after React hydration
scheduler(() => {
  Promise.all([
    import("./utils/visitorIntent").then(({ initVisitorTracking }) => initVisitorTracking()),
    import("./utils/performanceMonitoring").then(({ initPerformanceMonitoring }) => initPerformanceMonitoring())
  ]).catch(err => console.error("Failed to load tracking:", err));
}, { timeout: 3000 });
